import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    height: '3rem',

    '& .title': {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '1.125rem',
      fontSize: theme.size.base
    }
  }
}))

export default useStyles
